import Apify from '@module/apify';

export default Apify({
  getAccount: {
    path: '/api/v4/accounts/{accountId}',
    method: 'GET',
    pathExt: true,
  },

  editAccount: {
    path: '/api/v4/accounts/{accountId}',
    pathExt: true,
    method: 'PUT',
  },

  createSubdomain: {
    path: '/api/v4/accounts/{accountId}/subdomains',
    pathExt: true,
    method: 'POST',
  },

  validate: {
    path: '/api/v4/accounts/validate',
    method: 'POST',
  },

  validateSignup: {
    path: '/api/v4/accounts/signup/validate',
    method: 'POST',
  },

  validateSubdomain: {
    path: '/api/v4/accounts/subdomains/validate',
    method: 'POST',
  },

  getLastOrder: {
    path: '/api/v4/nu_subscriptions/{subscriptionId}/order',
    method: 'GET',
    pathExt: true,
  },

  getPaypalRedirect: {
    path: '/api/v4/nu_subscriptions/{subscriptionId}/complete',
    method: 'POST',
    pathExt: true,
  },

  getCheckoutDetails: {
    path: '/api/v4/nu_subscriptions/{subscriptionId}/checkout',
    method: 'GET',
    pathExt: true,
  },

  getSubscriptionDetails: {
    path: '/api/v4/nu_subscriptions/{subscriptionId}',
    pathExt: true,
    method: 'GET',
  },

  cancelSubscription: {
    path: '/api/v4/nu_subscriptions/{subscriptionId}/cancel',
    method: 'PUT',
    pathExt: true,
  },

  reactivateSubscription: {
    path: '/api/v4/nu_subscriptions/{subscriptionId}/reactivate',
    method: 'PUT',
    pathExt: true,
  },

  sendReceivingEmailConfirmation: {
    path: '/api/v4/accounts/receiving-email-confirmation/resend',
    method: 'POST',
  },

  duplicateSubscription: {
    path: '/api/v4/nu_subscriptions/{subscriptionId}/duplicate',
    method: 'POST',
    pathExt: true,
  },

  upgradeSubscription: {
    path: '/api/v4/nu_subscriptions/{subscriptionId}/upgrade',
    method: 'POST',
    pathExt: true,
  },

  uploadWallpaper: {
    path: '/api/v4/images/thumbs/wallpapers',
    method: 'POST',
  },

  uploadEmailBackground: {
    path: '/api/v4/images/thumbs/email_backgrounds',
    method: 'POST',
  },

  updatePaymentPlan: {
    path: '/api/v4/nu_subscriptions/{subscriptionId}/plan',
    method: 'PUT',
    pathExt: true,
  },

  confirmReceivingEmail: {
    path: '/api/v4/accounts/receiving-email-confirmation/confirm',
    method: 'PUT',
  },
});
